<div class="pay-options">
    @for (paymentMethod of paymentMethods; track paymentMethod.key) {
        @if (paymentMethod.key === 'applepay') {
            <div class="apple-pay-button" [class.disabled]="disabled" lang="en" (click)="selectMethod(paymentMethod)"></div>
        } @else if (paymentMethod.key === 'googlepay') {
            <div id="gpay-button-container" class="google-pay-button"></div>
        } @else {
            <button class="btn" type="button" [attr.data-testid]="'pay-option-' + paymentMethod.key" [disabled]="disabled" (click)="selectMethod(paymentMethod)">
                {{ paymentMethod.name }}
            </button>

        }
    }
</div>
